import { tw } from 'twind/css';

import { Maybe } from '__generated__/graphql';
import { useTranslate } from 'hooks/useTranslations';
import { Img } from 'ui/components/Img';
import { Price } from 'ui/components/Price';

export const GiftCardItem = ({
  amount,
  imageUrl,
  recipientEmail,
  recipientName,
  senderName,
  message,
}: {
  amount: number;
  imageUrl: string;
  recipientEmail: string;
  recipientName: string;
  senderName: string;
  message?: Maybe<string>;
}) => {
  const translate = useTranslate();
  return (
    <div className="flex">
      <div className="w-32 mr-4">
        <Img src={imageUrl} alt={translate('giftCard')} />
      </div>
      <div className="flex-grow">
        <div className="flex justify-between">
          <h2 className="font-bold pb-1 text-puma-black text-base leading-tight">
            {translate('digitalGiftCard')}
          </h2>
          <p className="capitalize text-puma-black font-bold whitespace-nowrap">
            <Price amount={amount} />
          </p>
        </div>
        <div className={tw('text-xs xs:text-sm')}>
          <KeyValueRow
            label={translate('recipientEmail')}
            value={recipientEmail}
          />
          <KeyValueRow
            label={translate('recipientName')}
            value={recipientName}
          />
          <KeyValueRow label={translate('senderName')} value={senderName} />
          {message && (
            <KeyValueRow label={translate('message')} value={message} />
          )}
        </div>
      </div>
    </div>
  );
};

const KeyValueRow = ({ label, value }: { label: string; value: string }) => (
  <p className="text-xs xs:text-sm flex flex-wrap break-all pb-2">
    <span className="capitalize text-puma-black-300">{label}:&nbsp;</span>
    <span>{value}</span>
  </p>
);
